import { render, staticRenderFns } from "./peopleEdit.vue?vue&type=template&id=a51fb256&scoped=true"
import script from "./peopleEdit.vue?vue&type=script&lang=js"
export * from "./peopleEdit.vue?vue&type=script&lang=js"
import style0 from "./peopleEdit.vue?vue&type=style&index=0&id=a51fb256&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51fb256",
  null
  
)

export default component.exports